module.exports = __webpack_public_path__ + "static/media/QR_CODE.2d2cf75d.png";